/**
 * Settle the cart queue and gift reconcile on checkout intent, so nobody
 * navigates to checkout mid-mutation. Display only, no prefetch, no prerender.
 *
 * Quiet settle (21 Oct 2026): the settle is a background read (about 1s), but
 * the queue marks the drawer is-cart-busy for it, which dimmed the line items,
 * bird fields, trust strip and protection row to 0.6 and back every time the
 * mouse reached Checkout. While a settle runs, #CartDrawer gets
 * is-cart-settling and sc-cart-drawer.css keeps everything at full opacity.
 * A real mutation already in flight keeps its normal busy state.
 */
(function () {
  if (window.__SC_CHECKOUT_PREWARM__) return;
  window.__SC_CHECKOUT_PREWARM__ = true;

  var SELECTOR = 'button[name="checkout"], [name="checkout"], .cart__checkout';
  var COOLDOWN_MS = 2500;
  var HOVER_DWELL_MS = 80;
  var QUIET_RELEASE_MS = 200; // the queue clears is-cart-busy 80ms after it goes idle
  var lastRun = 0;
  var hoverTimer = null;
  var quietTimer = null;

  function quiet(result) {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || !result || typeof result.then !== 'function') return;
    // A user mutation is already running: leave its busy state visible.
    if (drawer.classList.contains('is-cart-busy') && !drawer.classList.contains('is-cart-settling')) return;
    clearTimeout(quietTimer);
    drawer.classList.add('is-cart-settling');
    var release = function () {
      clearTimeout(quietTimer);
      quietTimer = setTimeout(function () {
        drawer.classList.remove('is-cart-settling');
      }, QUIET_RELEASE_MS);
    };
    result.then(release, release);
  }

  function settleCart(source) {
    var now = Date.now();
    if (now - lastRun < COOLDOWN_MS) return;
    lastRun = now;
    var result = null;
    if (typeof window.SC_reconcileGiftsIdle === 'function') {
      result = window.SC_reconcileGiftsIdle(source);
    } else if (typeof window.SC_getSharedCart === 'function') {
      result = window.SC_getSharedCart({ forceFresh: true });
      if (result && typeof result.catch === 'function') result = result.catch(function () {});
    }
    quiet(result);
  }

  function isCheckout(target) {
    return target && target.closest && target.closest(SELECTOR);
  }

  document.addEventListener('pointerover', function (e) {
    if (!isCheckout(e.target)) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () { settleCart('checkout-hover'); }, HOVER_DWELL_MS);
  }, { capture: true, passive: true });

  document.addEventListener('pointerout', function (e) {
    if (isCheckout(e.target)) clearTimeout(hoverTimer);
  }, { capture: true, passive: true });

  document.addEventListener('pointerdown', function (e) {
    if (isCheckout(e.target)) settleCart('checkout-pointerdown');
  }, { capture: true, passive: true });

  document.addEventListener('touchstart', function (e) {
    if (isCheckout(e.target)) settleCart('checkout-touchstart');
  }, { capture: true, passive: true });
})();
